import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'
import { stimulus } from '~/init'

export default class AiAddProductController extends Controller {
  static values = { url: String }

  add (event) {
    const product = JSON.parse(event.currentTarget.dataset.product)
    if (!product || !product.id) return

    if (this.urlValue) {
      this.#addViaApi(event.currentTarget, product)
    } else {
      document.dispatchEvent(new CustomEvent('repeat-products', {
        detail: { products: [product] }
      }))
      this.#showSuccess(event.currentTarget)
    }
  }

  async #addViaApi (btn, product) {
    btn.disabled = true
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const isBulk = product.is_bulk === true || product.unit === 'л'
    const defaultQty = isBulk ? 1.0 : 1

    try {
      const resp = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
          Accept: 'text/vnd.turbo-stream.html'
        },
        body: JSON.stringify({
          product_id: product.id,
          quantity: defaultQty,
          price_at_time: product.price
        })
      })

      if (resp.ok) {
        const html = await resp.text()
        if (html) Turbo.renderStreamMessage(html)
        this.#showSuccess(btn)
      } else {
        btn.disabled = false
      }
    } catch {
      btn.disabled = false
    }
  }

  #showSuccess (btn) {
    btn.innerHTML = '<svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>'
    btn.classList.remove('hover:text-green-600', 'text-muted-foreground')
    btn.classList.add('text-green-600')
    btn.disabled = true
  }
}

stimulus.register('ai-add-product', AiAddProductController)
